export default __webpack_public_path__ + "static/media/continueArrow.c2a3410a.svg";